import { defineMessages } from "react-intl";

export const messages = defineMessages({
  lowerThan: {
    defaultMessage: "lower than {value}",
    id: "qSCmIG",
  },
  or: {
    defaultMessage: "or",
    id: "jNqmiH",
    description: "conjunction between order rule condition chips",
  },
  greaterThan: {
    defaultMessage: "greater than {value}",
    id: "lZC/1a",
  },
});
